import { useEffect, useState } from "react";

const useIsScrolled = (distance: number = 30) => {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    if (typeof window === "undefined") return;

    const onScroll = () => {
      setIsScrolled(window.scrollY > distance);
    };

    window.addEventListener("scroll", onScroll);

    // Run initially once (after hydration)
    onScroll();

    return () => {
      window.removeEventListener("scroll", onScroll);
    };
  }, [distance]);

  return isScrolled;
};

export default useIsScrolled;
